module.exports = __webpack_public_path__ + "img/timg.3da3b68e.jpg";